import React from 'react'
import CreditCard3D from './CreditCard3D'

const FintechShowcase: React.FC = () => {
  return (
    <section className="py-20 bg-brand-dark relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            Modern <span className="gradient-text">Payment Solutions</span>
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Experience the future of payments with our cutting-edge technology and seamless integrations
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Side - Fintech App Mockups */}
          <div className="space-y-8">
            <div className="glass-card-intense p-8 rounded-2xl tech-3d">
              <h3 className="text-2xl font-bold mb-4 gradient-text">Mobile Payment App</h3>
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 mb-4">
                <div className="flex items-center justify-between mb-4">
                  <div className="w-8 h-8 bg-gradient-to-r from-blue-500 to-purple-600 rounded-full"></div>
                  <div className="text-sm text-gray-400">Universal Pay</div>
                </div>
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-gray-300">Balance</span>
                    <span className="text-2xl font-bold text-white">$12,450.00</span>
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div className="glass-card p-3 rounded-lg text-center">
                      <div className="text-blue-400 mb-1">💳</div>
                      <div className="text-xs text-gray-400">Cards</div>
                    </div>
                    <div className="glass-card p-3 rounded-lg text-center">
                      <div className="text-green-400 mb-1">📱</div>
                      <div className="text-xs text-gray-400">Mobile</div>
                    </div>
                  </div>
                </div>
              </div>
              <p className="text-gray-300">
                Intuitive mobile interface for seamless payment management and real-time transaction monitoring.
              </p>
            </div>

            <div className="glass-card-intense p-8 rounded-2xl tech-3d">
              <h3 className="text-2xl font-bold mb-4 gradient-text">Dashboard Analytics</h3>
              <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-xl p-6 mb-4">
                <div className="grid grid-cols-3 gap-4 mb-4">
                  <div className="text-center">
                    <div className="text-2xl font-bold text-green-400">98.5%</div>
                    <div className="text-xs text-gray-400">Success Rate</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-blue-400">2.1s</div>
                    <div className="text-xs text-gray-400">Avg Response</div>
                  </div>
                  <div className="text-center">
                    <div className="text-2xl font-bold text-purple-400">24/7</div>
                    <div className="text-xs text-gray-400">Uptime</div>
                  </div>
                </div>
                <div className="h-20 bg-gradient-to-r from-blue-500/20 to-purple-600/20 rounded-lg flex items-end justify-around p-2">
                  <div className="w-4 bg-blue-500 rounded-t" style={{ height: '60%' }}></div>
                  <div className="w-4 bg-purple-500 rounded-t" style={{ height: '80%' }}></div>
                  <div className="w-4 bg-blue-500 rounded-t" style={{ height: '70%' }}></div>
                  <div className="w-4 bg-purple-500 rounded-t" style={{ height: '90%' }}></div>
                  <div className="w-4 bg-blue-500 rounded-t" style={{ height: '85%' }}></div>
                </div>
              </div>
              <p className="text-gray-300">
                Comprehensive analytics dashboard with real-time insights and performance metrics.
              </p>
            </div>
          </div>

          {/* Right Side - Credit Cards & 3D Elements */}
          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-r from-blue-500/10 to-purple-600/10 rounded-3xl blur-3xl"></div>

            {/* Main Credit Card Image */}
            <div className="relative mb-8">
              <img
                src="/assets/andrei-castanha-PgpLVTFl6mc-unsplash-removebg-preview.png"
                alt="Payment Cards"
                className="w-full max-w-md h-auto floating-card mx-auto"
                style={{ animationDelay: '0s' }}
              />
            </div>

            {/* Additional 3D Cards */}
            <div className="relative space-y-6">
              <div className="floating-card opacity-80" style={{ animationDelay: '1s' }}>
                <CreditCard3D type="visa" className="transform rotate-6 mx-auto" />
              </div>
              <div className="floating-card ml-12 opacity-70" style={{ animationDelay: '3s' }}>
                <CreditCard3D type="mastercard" className="transform -rotate-3" />
              </div>
            </div>
          </div>
        </div>

        {/* Features Grid */}
        <div className="mt-20 grid md:grid-cols-3 gap-8">
          {[
            {
              icon: '🔒',
              title: 'Bank-Level Security',
              description: 'Advanced encryption and fraud protection for all transactions'
            },
            {
              icon: '⚡',
              title: 'Lightning Fast',
              description: 'Process payments in under 2 seconds with 99.9% uptime'
            },
            {
              icon: '🌍',
              title: 'Global Reach',
              description: 'Accept payments from customers worldwide in 150+ currencies'
            }
          ].map((feature, index) => (
            <div
              key={feature.title}
              className="glass-card p-6 rounded-xl text-center hover:scale-105 transition-all duration-300"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="text-4xl mb-4">{feature.icon}</div>
              <h3 className="text-xl font-bold mb-2">{feature.title}</h3>
              <p className="text-gray-300">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default FintechShowcase
